
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rwg-bridge/login",
      function () {
        return require("private-next-pages/rwg-bridge/login.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rwg-bridge/login"])
      });
    }
  